import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from '../../globals';
import { Login } from '../modal/login';
import { pincode } from '../modal/pincode';
import { Observable } from 'rxjs';
import { User, UserDTO } from '../modal/user';


@Injectable({
    providedIn: 'root'
})

export class CampRegistrationService {
    constructor(private httpclient: HttpClient, private global: Globals) { }


    GetPincode(pincode) {
        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get<pincode[]>(this.global.G_apiUrl + "/userRegistration/pincodeSearch/" + `${pincode}`, { headers: headers });
    }


    registerCampUser(user) {
        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.post<User>(this.global.G_apiUrl + "/userRegistration/campRegistration", user, { headers: headers });
    }

    checkReferralCode(code) {
        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get(this.global.G_apiUrl + "/userRegistration/checkReferralcode/" + `${code}`, { responseType: 'text', headers: headers });
    }
    VerifyName(name, mobileno) {
        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get(this.global.G_apiUrl + "/userRegistration/checkName/" + `${name}` + `/${mobileno}`, { responseType: 'text',  headers: headers });
    }

    updateCampRegiserUser(userObj){
        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.put<User>(this.global.G_apiUrl + "/userRegistration/updateCampRegiserUser",userObj,{ headers: headers });
    }

}



